import { Component, Input, OnChanges } from '@angular/core';
import * as _ from 'lodash';
import { UtlPerFinService } from '../../utl-per-fin.service';

@Component({
  selector: 'main-table',
  template: `
    <table-header 
      [isMobile]="isMobile" 
      [columnHeader]="columnHeader" 
      [headerData]="sectionHeaderToDisplay" 
      [firstSectionDisplayed]="firstSectionDisplayed"
      [topLevelHeaderToDisplay]="topLevelHeaderToDisplay"></table-header>

    <div *ngFor="let mainSectionData of sectionToDisplay">
      <table-main-section  [isMobile]="isMobile" [columnHeader]="columnHeader"  [mainSectionData]="mainSectionData"></table-main-section>
    </div>
  `
})
export class MainTableComponent implements OnChanges {
  @Input() tableData;
  @Input() isMobile;
  @Input() columnHeader;
  headerData;
  sectionsToDisplay;

  constructor(private utlPerFinService: UtlPerFinService) {
    this.utlPerFinService.horizontalScrollTableColumns.subscribe(requestedColumns => {
      if (requestedColumns === 'next') {
        this.getNextColumns();
      } else if (requestedColumns === 'last') {
        this.getLastColumns();
      }
    });
  }
  ngOnChanges() {
    this.getMainSectionData();
    this.buildColumnsbySection();
    this.builColumnSectionHeaders();
  }

  // todo to many variables refactor into objects
  firstSection;
  secondSection;
  newBornOutpatientVisits;
  fullTimeEquivPersonnel;
  fullTimeEquivTrainnes;
  laborExpenses;
  totalExpenses;

  firstSectionHeader;
  secondSectionHeader;
  newBornOutpatientVisitsHeader;
  fullTimeEquivPersonnelHeader;
  fullTimeEquivTrainnesHeader;
  laborExpensesHeader;
  totalExpensesHeader;

  sectionToDisplay;
  sectionHeaderToDisplay;

  firstSectionDisplayed = true;
  topLevelHeaderToDisplay;

  getNextColumns() {
    switch (this.sectionToDisplay) {
      case this.firstSection:
        this.sectionToDisplay = this.secondSection;
        this.sectionHeaderToDisplay = this.secondSectionHeader;
        this.firstSectionDisplayed = false;
        this.topLevelHeaderToDisplay = '';
        break;
      case this.secondSection:
        this.sectionToDisplay = this.newBornOutpatientVisits;
        this.sectionHeaderToDisplay = this.newBornOutpatientVisitsHeader;
        this.topLevelHeaderToDisplay = 'New Borns & Outpatient Visits';
        break;
      case this.newBornOutpatientVisits:
        this.sectionToDisplay = this.fullTimeEquivPersonnel;
        this.sectionHeaderToDisplay = this.fullTimeEquivPersonnelHeader;
        this.topLevelHeaderToDisplay = 'Full-Time Equiv Personnel';
        break;
      case this.fullTimeEquivPersonnel:
        this.sectionToDisplay = this.fullTimeEquivTrainnes;
        this.sectionHeaderToDisplay = this.fullTimeEquivTrainnesHeader;
        this.topLevelHeaderToDisplay = 'Full-Time Equiv Trainees';
        break;
      case this.fullTimeEquivTrainnes:
        this.sectionToDisplay = this.firstSection;
        this.sectionHeaderToDisplay = this.firstSectionHeader;
        this.firstSectionDisplayed = true;
        this.topLevelHeaderToDisplay = '';
        break;

      default:
        this.sectionToDisplay = this.firstSection;
        this.sectionHeaderToDisplay = this.firstSectionHeader;
        this.firstSectionDisplayed = true;
    }
  }

  getLastColumns() {
    switch (this.sectionToDisplay) {
      case this.firstSection:
        break;
      case this.secondSection:
        this.sectionToDisplay = this.firstSection;
        this.sectionHeaderToDisplay = this.firstSectionHeader;
        this.firstSectionDisplayed = true;
        this.topLevelHeaderToDisplay = '';
        break;
      case this.newBornOutpatientVisits:
        this.sectionToDisplay = this.secondSection;
        this.sectionHeaderToDisplay = this.secondSectionHeader;
        this.topLevelHeaderToDisplay = '';
        break;
      case this.fullTimeEquivPersonnel:
        this.sectionToDisplay = this.newBornOutpatientVisits;
        this.sectionHeaderToDisplay = this.newBornOutpatientVisitsHeader;
        this.topLevelHeaderToDisplay = 'New Borns & Outpatient Visits';
        break;
      case this.fullTimeEquivTrainnes:
        this.sectionToDisplay = this.fullTimeEquivPersonnel;
        this.sectionHeaderToDisplay = this.fullTimeEquivPersonnelHeader;
        this.topLevelHeaderToDisplay = 'Full-Time Equivalent Personnel';
        break;

      default:
        this.sectionToDisplay = this.firstSection;
        this.sectionHeaderToDisplay = this.firstSectionHeader;
        this.firstSectionDisplayed = true;
    }
  }

  getMainSectionData() {
    this.sectionsToDisplay = this.tableData.data.section;
  }

  sectionHeaderFinder(arr) {
    let headers = _.map(Object.assign([], this.tableData.data.section[0].row[0].cell), 'label');
    return _.pullAt(headers, arr);
  }

  // this function basically helps get data for x amount of columns, it takes in as an argument
  // the array has numbers that correspond to columns we want to get back for displaying
  // we are using Object.assign to keep things as immutable as possible
  sectionFinder(arr) {
    return this.tableData.data.section.map(function(section) {
      let rowOfFive = _.pullAt(Object.assign([], section.row[0].cell), arr);
      let subsections = section.subsection.map(function(subsection) {
        if (subsection.label === 'Metropolitan' && subsection.subsection !== null) {
          let rowOfFiveSubsection = _.pullAt(Object.assign([], subsection.row[0].cell), arr);

          let newSub = subsection.subsection.map(function(row) {
            let rowOfFiveMetropolitan = _.pullAt(Object.assign([], row.row[0].cell), arr);
            return { label: row.label, row: rowOfFiveMetropolitan };
          });

          return {
            label: subsection.label,
            row: rowOfFiveSubsection,
            subsection: newSub
          };
        } else {
          let rowOfFiveSubsection = _.pullAt(Object.assign([], subsection.row[0].cell), arr);
          return { label: subsection.label, row: rowOfFiveSubsection };
        }
      });

      return { label: section.label, row: rowOfFive, subsections: subsections };
    });
  }

  builColumnSectionHeaders() {
    this.firstSectionHeader = this.sectionHeaderFinder([0, 1, 2, 3, 4]);
    this.secondSectionHeader = this.sectionHeaderFinder([5, 6, 7, 8]);
    this.newBornOutpatientVisitsHeader = this.sectionHeaderFinder([9, 10, 11, 12]);
    this.fullTimeEquivPersonnelHeader = this.sectionHeaderFinder([13, 14, 15, 16, 17]);
    this.fullTimeEquivTrainnesHeader = this.sectionHeaderFinder([18, 19, 20]);
    this.laborExpensesHeader = this.sectionHeaderFinder([21, 22, 23, 24]);
    this.totalExpensesHeader = this.sectionHeaderFinder([25, 26, 27]);
    if (this.isMobile) {
      this.sectionHeaderToDisplay = this.sectionHeaderFinder([
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27
      ]);
    } else {
      this.sectionHeaderToDisplay = this.firstSectionHeader;
    }
  }

  buildColumnsbySection() {
    this.firstSection = this.sectionFinder([0, 1, 2, 3, 4]);
    this.secondSection = this.sectionFinder([5, 6, 7, 8]);
    this.newBornOutpatientVisits = this.sectionFinder([9, 10, 11, 12]);
    this.fullTimeEquivPersonnel = this.sectionFinder([13, 14, 15, 16, 17]);
    this.fullTimeEquivTrainnes = this.sectionFinder([18, 19, 20]);
    this.laborExpenses = this.sectionFinder([21, 22, 23, 24]);
    this.totalExpenses = this.sectionFinder([25, 26, 27]);
    if (this.isMobile) {
      this.sectionToDisplay = this.sectionFinder([
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27
      ]);
    } else {
      this.sectionToDisplay = this.firstSection;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/t8-utl-per-fin/components-utl-per-fin/main-table/main-table.component.ts